"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InAppAgentToolApprovalSchema = exports.InAppAgentToolApprovalSourceSchema = exports.InAppAgentApprovalDecisionSchema = exports.IN_APP_AGENT_TOOL_APPROVAL_EVENT_NAME = exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME = void 0;
exports.buildInAppAgentApprovalDecisionEvent = buildInAppAgentApprovalDecisionEvent;
exports.parseInAppAgentApprovalDecisionEvent = parseInAppAgentApprovalDecisionEvent;
exports.buildInAppAgentToolApprovalEvent = buildInAppAgentToolApprovalEvent;
exports.parseInAppAgentToolApprovalEvent = parseInAppAgentToolApprovalEvent;
const core_1 = require("@ag-ui/core");
const zod_1 = require("zod");
/** Render-only approval history stored in the append-only event stream. */
exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME = "langfuse_approval_decision";
exports.IN_APP_AGENT_TOOL_APPROVAL_EVENT_NAME = "langfuse_tool_approval";
exports.InAppAgentApprovalDecisionSchema = zod_1.z.object({
    toolCallId: zod_1.z.string().min(1),
    approved: zod_1.z.boolean(),
    decidedByUserId: zod_1.z.string().min(1),
    alwaysAllow: zod_1.z.literal(true).optional(),
    toolName: zod_1.z.string().min(1).optional(),
});
exports.InAppAgentToolApprovalSourceSchema = zod_1.z.enum([
    "auto",
    "human",
    "conversation_grant",
]);
exports.InAppAgentToolApprovalSchema = zod_1.z.object({
    toolCallId: zod_1.z.string().min(1),
    toolName: zod_1.z.string().min(1),
    source: exports.InAppAgentToolApprovalSourceSchema,
});
function buildInAppAgentApprovalDecisionEvent(decision) {
    return {
        type: core_1.EventType.CUSTOM,
        name: exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME,
        value: decision,
    };
}
function parseInAppAgentApprovalDecisionEvent(event) {
    if (event.type !== core_1.EventType.CUSTOM ||
        event.name !== exports.IN_APP_AGENT_APPROVAL_DECISION_EVENT_NAME) {
        return undefined;
    }
    const parsed = exports.InAppAgentApprovalDecisionSchema.safeParse(event.value);
    return parsed.success ? parsed.data : undefined;
}
function buildInAppAgentToolApprovalEvent(approval) {
    return {
        type: core_1.EventType.CUSTOM,
        name: exports.IN_APP_AGENT_TOOL_APPROVAL_EVENT_NAME,
        toolCallId: approval.toolCallId,
        value: approval,
    };
}
function parseInAppAgentToolApprovalEvent(event) {
    if (event.type !== core_1.EventType.CUSTOM ||
        event.name !== exports.IN_APP_AGENT_TOOL_APPROVAL_EVENT_NAME) {
        return undefined;
    }
    const parsed = exports.InAppAgentToolApprovalSchema.safeParse(event.value);
    return parsed.success ? parsed.data : undefined;
}
